import { Tooltip } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

function formatHistoryDate(dateString) {
  const date = new Date(dateString);
  return !dateString || Number.isNaN(date.getTime()) ? "N/A" : date.toLocaleString("en-US");
}

export default function ApprovalDateTooltip({ caseDetail }) {
  return (
    <Tooltip
      arrow
      placement="top"
      title={(
        <div className="flex flex-col gap-1 text-[12px]">
          <div>
            <strong>Approved At:</strong> {formatHistoryDate(caseDetail?.reductionApprovedAt)}
          </div>
          <div>
            <strong>Approved By:</strong> {caseDetail?.reductionApprovedBy || "N/A"}
          </div>
        </div>
      )}
    >
      <span className="flex items-center">
        <Svg
          name={SvgEnum.HisInfo}
          color={HNSColors.primary[500]}
          sx={SETTLEMENT_STYLES.infoIcon}
        />
      </span>
    </Tooltip>
  );
}
